import { ReactNode } from "react";
import { HourScopeProvider } from "./hourAnimation.jsx";
import { RadarIsCheckedProvider } from "./radarIsChecked.jsx";
import { PreviousAndNextImageProvider } from "./previousAndNextImage.jsx";
import { StationsVisibleProvider } from "./radarFilter.jsx";
import { CodeStationsProvider } from "./codeStation.jsx";
import { FilterTypeRadarProvider } from "./typeRadarContext.js";
import { RadarOrSateliteProvider } from "./RadarOrSatelite.jsx";
import { ButtonSatProvider } from "./buttonSat";
import { PhenomenaProvider } from "./Phenomena.jsx";
import { CheckedsProvider } from "./Checkeds.jsx";
import { ImageProvider } from "./satImageUpdate.js";
import { WrfImagesProvider } from "./wrfImages";
import { ScopeDaysProvider } from "./ScopeDays.jsx";
import { RadarPlayerProvider } from "./radarPlayer";


interface CombinedProvidersProps {
  children: ReactNode;
}

export function CombinedProviders({ children }: CombinedProvidersProps) {
  return (
    <HourScopeProvider>
      <ScopeDaysProvider>
        <CheckedsProvider>
          <ImageProvider>
            <WrfImagesProvider>
              <ButtonSatProvider>
                <RadarIsCheckedProvider>
                  <PreviousAndNextImageProvider>
                    <StationsVisibleProvider>
                      <CodeStationsProvider>
                        <FilterTypeRadarProvider>
                          <PhenomenaProvider>
                            <RadarOrSateliteProvider>
                              <RadarPlayerProvider>
                                {children}
                              </RadarPlayerProvider>
                            </RadarOrSateliteProvider>
                          </PhenomenaProvider>
                        </FilterTypeRadarProvider>
                      </CodeStationsProvider>
                    </StationsVisibleProvider>
                  </PreviousAndNextImageProvider>
                </RadarIsCheckedProvider>
              </ButtonSatProvider>
            </WrfImagesProvider>
          </ImageProvider>
        </CheckedsProvider>
      </ScopeDaysProvider>
    </HourScopeProvider>
  );
}
